import styled, { keyframes, css } from 'styled-components';
import * as Dialog from '@radix-ui/react-dialog';
import { WRAPPER } from '@/shared/styles/themes';
import { Button } from '@/shared/ui/form/button';
import { Image } from '@/shared/ui/image';
import ArrowLeftAuth from '@/shared/assets/arrow-left-auth.svg';

export const Wrapper = styled.div`
  ${WRAPPER}
  display:flex;
  margin-top: 16px;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const StyledAlertDialogOverlay = styled(Dialog.Overlay)`
  position: fixed;
  background: rgba(39, 38, 43, 0.65);
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  z-index: 0;
  display: grid;
  z-index: 11;
  place-items: center;
  overflow-y: auto;
`;
export const DialogOptionsList = styled.div``;

export const ArrowLeftAuthIcon = styled(ArrowLeftAuth)`
  position: absolute;
  top: 16px;
  cursor: pointer;
  left: 16px;
`;

export const StyledAlertDialogContent = styled(Dialog.Content)`
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 12;
  box-shadow: 0px 0px 250px 50px #131315;
  background-color: #131315;
  transform: translate(-50%, -50%);
  border-radius: 12px;
  max-height: 100vh;
  overflow: ${(props) => (props.$overflow ? props.$overflow : 'auto')};
  z-index: 100;
  @media screen and (max-width: 768px) {
    top: 0;
    left: 0;
    transform: translate(0, 0);
    box-shadow: none;
    width: 100%;
    height: 100%;
    border-radius: 0;
  }

  @media (orientation: landscape) and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }
`;

export const FormWrapper = styled.div`
  width: 364px;
  padding-top: 0;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  border-radius: 8px;
  position: relative;
  border: 1px solid #131315;
  background: #131315;

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100%;
    z-index: 10;
    overflow: auto;

    ${(props) =>
      props.$currentStep == 'authorization' &&
      css`
        &:before {
          content: '';
          position: absolute;
          width: 25%;
          height: 100%;
          top: 0;
          left: 0;
          background-color: ${props.$authenticationType === 'signin'
            ? '#131315'
            : '#27262B'};
          z-index: 1;
          overflow: hidden;
          border-radius: 23px;
          opacity: 0;
        }
        &:after {
          content: '';
          position: absolute;
          width: 25%;
          height: 100%;
          top: 0;
          right: 0;
          background-color: ${props.$authenticationType !== 'signin'
            ? '#131315'
            : '#27262B'};
          z-index: 0;
          overflow: hidden;
          border-radius: 23px;
        }
      `}
  }

  form {
    width: 100%;
  }
`;

export const FormChangeSections = styled.div`
  display: flex;
  height: 48px;
  padding: 4px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border: 1px solid #3d3c41;
  border-radius: 12px;
`;

export const ButtonContinue = styled(Button)`
  width: 100%;
  background: linear-gradient(89deg, #ff9500 0.66%, #ff5e00 116.39%);
  border-radius: 8px;
  height: 48px;
`;
export const FormTypeSection = styled.div`
  display: flex;
  padding: 20.5px 16px;
  justify-content: center;
  align-items: center;
  gap: 12px;
  flex: 1 0 0;
  position: relative;
  z-index: 2;
  cursor: pointer;
  border-radius: 23px;
  ${({ $isActive }) =>
    $isActive &&
    `
    position: relative;
    background:  #131315;

    `}
  ${({ $isActive }) =>
    !$isActive &&
    `
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 12px;
    background:#27262B;

    `}
    ${({ $type }) =>
    $type === 'signin' &&
    `
    border-bottom-right-radius: 12px;
    border-bottom-left-radius: 0;

    `}
     ${({ $type }) =>
    $type === 'signup' &&
    `
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 12px;

    `}
      ${({ $type }) =>
    $type === 'close' &&
    `
   border-bottom-right-radius: 12px;
    border-bottom-left-radius: 0px;
    background:#27262B;
    height:100%;
    flex:none;
    `}
`;

export const FormTypeSections = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;
  position: relative;
  height: 60px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    width: 100%;
    height: 50%;
    top: 0;
    background-color: #27262b;
    z-index: 1;
    overflow: hidden;
  }
  &:after {
    content: '';
    width: 100%;
    height: 50%;
    bottom: 0;
    position: absolute;
    background-color: #131315;
  }

  @media screen and (max-width: 768px) {
    border-top-right-radius: 0px;
    border-top-left-radius: 0px;
  }
`;
export const FormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 18px;
  border-radius: 23px;
  background-color: #131315;
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  z-index: 1;

  @media screen and (max-width: 768px) {
    border-radius: 0;
    height: calc(100% - 60px);
    padding: 18px;
    overflow: scroll;
    ${({ $viewInfo }) =>
      $viewInfo &&
      `
  background: rgba(19, 19, 21, 0.75);
    backdrop-filter: blur(18px);
  `}
  }
`;

export const AuthCloseIconImage = styled(Image)`
  position: absolute;
  top: 18px;
  right: 18px;
  cursor: pointer;
  z-index: 100;

  ${({ $currentStep }) =>
    $currentStep === 'email-confirmation' &&
    `
    top: 16px;
    right: 16px;
  `}
`;
export const LogoutIcon = styled.div`
  background-image: url('/images/background/logout-icon-new-des.png');
  width: 256px;
  height: 256px;
  aspect-ratio: 1/1;
  background-size: cover;
  margin: 95px auto 0;
  flex-shrink: 0;
  mix-blend-mode: lighten;
  @media screen and (max-width: 768px) {
    margin: auto;
    background-image: url('/images/background/logout-icon-new-mob.png');
  }
`;

export const CloseIconImage = styled(Image)`
  position: absolute;
  top: 20px;
  right: 16px;
  cursor: pointer;
`;

export const spinAnimation = keyframes`
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(359deg);
  }
`;

export const SpinnerBox = styled.div`
  position: relative;
`;

export const CircleBorder = styled.div`
  width: 120px;
  height: 120px;
  margin: 0 auto;
  padding: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: linear-gradient(
    rgba(31, 120, 255, 0.1) 33%,
    rgb(249 249 249) 100%
  );
  animation: ${spinAnimation} 0.8s linear 0s infinite;
`;

export const CircleCore = styled.div`
  width: 100%;
  height: 100%;
  background-color: #1d2630;
  border-radius: 50%;
  background-color: rgba(27, 32, 45, 0.96);
`;

export const CircleImage = styled(Image)`
  position: absolute;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const ConfirmationFormWrapper = styled.div`
  display: flex;
  gap: 6px;

  input {
    flex-basis: 25%;
    border-radius: 8px;
    border: 1px solid var(--2-c-344-a-60, rgba(44, 52, 74, 0.6));
    background: var(--2-c-344-a-40, #27262b);
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 28.8px */
    padding: 8px;
    text-align: center;
    color: var(--edeff-5, #edeff5);
    min-height: 64px;
    margin-top: 6px;
    &::placeholder {
      color: #afafaf;
    }
  }
`;

export const ConfirmationPhoneText = styled.div`
  margin-bottom: 24px;
  text-align: center;
  display: flex;
  gap: 6px;
  justify-content: center;
  align-items: center;

  img {
    cursor: pointer;
  }
`;

export const ResetPasswordBlock = styled.div`
  cursor: pointer;
`;

export const DialogScroll = styled.div`
  display: flex;
  overflow: auto;
  position: absolute;
  inset: 0;
`;

export const RegistrationsBonusImage = styled.div`
  background-image: url('/images/background/resgistration-bonus-border.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  height: 98px;
  text-align: center;
  padding-top: 16px;
`;

export const RegistrationsBonusTitle = styled.div`
  color: var(--edeff-5, #edeff5);
  text-shadow: 0px 2px 0px #241421;
  font-size: 19.635px;
  font-style: normal;
  font-weight: 900;
  line-height: 140%; /* 27.489px */
  text-transform: uppercase;
`;

export const RegistrationsBonusDesc = styled.div`
  text-shadow: 0px 2px 0px #241421;
  font-size: 35.505px;
  font-style: normal;
  font-weight: 900;
  line-height: 140%; /* 49.707px */
  text-transform: uppercase;
  color: #fca31e;
`;

export const LogoutDetails = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`;
export const BoxForSelectLanguage = styled.div`
  max-width: 200px;
  width: 100%;

  .language-select__value-container {
    justify-content: start !important;
  }
`;
